import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { jsPDF as JsPdf } from "jspdf";
import html2canvas from "html2canvas";
// import Switch from "@mui/material/Switch";

import Loading from "custom/Loading";
import DashboardLayout from "custom/LayoutContainers/DashboardLayout";
import DashboardNavbar from "custom/Navbars/DashboardNavbar";
import Footer from "custom/Footer";
import SuiBox from "components/SuiBox";
// import SuiTypography from "components/SuiTypography";
import SuiButton from "components/SuiButton";
import { Card, Grid } from "@mui/material";
import { connect } from "react-redux";
import { getGeneralClassReports } from "redux/actions/pages";
import SuiSelect from "components/SuiSelect";

import { getAcademicStartDate } from "layouts/reports/components/month.mapper";
import "./_class-reports.css";
import MonthlyTaskComparisonChart from "../../components/MonthlyTaskComparisonChart";
import MonthlyReadingTaskIncentiveOrNotComparison from "../../components/MonthlyReadingTaskIncentiveOrNotComparison";
import TaskCompletionSummary from "../../components/TaskCompletionSummary";
import QuizResults from "../../components/QuizResults";
import ReportHeader from "../../components/ReportHeader";
import ClassGeneralInfo from "../../components/ClassGeneralInfo";

const PageOrientationType = Object.freeze({
  portrait: "portrait",
  landscape: "landscape",
});

const delay = (ms) => new Promise((res) => setTimeout(res, ms));

const ClassReports = ({ getReports, generalClassReports, localizations, suborganization }) => {
  const pdfContainerRef = useRef();

  // const [showAverages, setShowAverages] = useState(true);
  const [selectedClassId, setSelectedClassId] = useState(0);
  const [selectedClass, setSelectedClass] = useState(null);

  useEffect(() => {
    if (suborganization > 0) {
      getReports({ academicStartDate: getAcademicStartDate() });
    }
  }, [suborganization]);

  useEffect(() => {
    if (generalClassReports?.length > 0) {
      setSelectedClassId(generalClassReports[0].id);
    }
  }, [generalClassReports]);

  useEffect(() => {
    if (selectedClassId > 0) {
      setSelectedClass(generalClassReports.find((cl) => cl.id === selectedClassId));
    }
  }, [selectedClassId]);

  const downloadPDFReport = async (e) => {
    e.preventDefault();
    const element = pdfContainerRef.current;
    element.style.display = "block";

    await delay(2000);

    const { clientHeight, clientWidth } = element;

    const canvas = await html2canvas(element, { scale: 1 });
    const data = canvas.toDataURL("image/jpeg", 100);

    const pageOrientation = PageOrientationType.portrait;

    const pdf = new JsPdf({ orientation: pageOrientation });

    const originalPdfWidth = pdf.internal.pageSize.getWidth();

    let pdfWidth = 0;
    let pdfHeight = 0;

    // calculate belongs to width
    pdfWidth = originalPdfWidth;
    pdfHeight = (originalPdfWidth * clientHeight) / clientWidth;

    pdf.addImage(data, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save("print.pdf");
    element.style.display = "none";
  };

  return (
    <>
      <Loading />
      <DashboardLayout>
        <DashboardNavbar />
        <SuiBox py={3}>
          <Grid container>
            <Grid item sm={7} xs={12} mb={{ xs: 2, sm: 0 }}>
              <h3>Sınıf Raporu</h3>
            </Grid>
            <Grid
              item
              size={{ sm: 5, xs: 12 }}
              flex={{ sm: true, xs: false }}
              ml={{ sm: "auto", xs: 0 }}
            >
              <div style={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
                {/* <SuiBox display="flex" mr={3}>
                  <SuiBox>
                    <Switch
                      checked={showAverages}
                      onChange={() => setShowAverages(!showAverages)}
                    />
                  </SuiBox>
                  <SuiBox width="80%" ml={1}>
                    <SuiTypography variant="button" fontWeight="regular" color="text">
                      Ortalama Göster
                    </SuiTypography>
                  </SuiBox>
                </SuiBox> */}
                <SuiButton
                  size="medium"
                  variant="contained"
                  color="error"
                  // color="info"
                  onClick={downloadPDFReport}
                >
                  {localizations?.REPORTS_DOWNLOAD_PDF_BTN_LABEL ?? "PDF İndir"}
                </SuiButton>
              </div>
            </Grid>
            {selectedClass !== null && selectedClass !== undefined ? (
              <Grid item xs={12} mt={3} xl={12}>
                <Card sx={{ overflow: "visible" }}>
                  <div className="class-reports-container">
                    <SuiBox pt={3} px={3}>
                      <Grid container spacing={2}>
                        <Grid item xs={12} xl={12}>
                          <ReportHeader />
                        </Grid>
                        <Grid item xs={12} xl={12}>
                          <div className="class-reports-line" />
                        </Grid>
                        <Grid item xs={12} xl={12}>
                          <Grid container spacing={2}>
                            <Grid item xs={12} md={6} lg={4}>
                              <SuiSelect
                                willMaxHeightBeUsed
                                onChange={(selected) => setSelectedClassId(selected.value)}
                                value={
                                  selectedClassId > 0
                                    ? generalClassReports
                                        ?.map((cl) => ({
                                          value: cl.id,
                                          label: `${cl.className} Sınıfı`,
                                        }))
                                        ?.find((cl) => cl.value === selectedClassId)
                                    : null
                                }
                                placeholder="Sınıf Seçiniz"
                                options={generalClassReports?.map((cl) => ({
                                  value: cl.id,
                                  label: `${cl.className} Sınıfı`,
                                }))}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item xs={12} xl={12}>
                          <ClassGeneralInfo
                            studentCount={selectedClass?.studentCount}
                            readingCount={
                              selectedClass?.generalInformation?.reduce((total, current) => {
                                if (current.type === "READ") {
                                  return total + current.count;
                                }
                                return total;
                              }, 0) ?? 0
                            }
                            listeningCount={
                              selectedClass?.generalInformation?.reduce((total, current) => {
                                if (current.type === "LISTEN") {
                                  return total + current.count;
                                }
                                return total;
                              }, 0) ?? 0
                            }
                            recordingCount={
                              selectedClass?.generalInformation?.reduce((total, current) => {
                                if (current.type === "RECORD") {
                                  return total + current.count;
                                }
                                return total;
                              }, 0) ?? 0
                            }
                            quizCount={
                              selectedClass?.generalInformation?.reduce((total, current) => {
                                if (current.type === "QUIZ") {
                                  return total + current.count;
                                }
                                return total;
                              }, 0) ?? 0
                            }
                          />
                        </Grid>
                        <Grid item xs={12} xl={6}>
                          <MonthlyTaskComparisonChart
                            monthlyResults={selectedClass?.monthlyResults}
                          />
                        </Grid>
                        <Grid item xs={12} xl={6}>
                          <MonthlyReadingTaskIncentiveOrNotComparison
                            monthlyResults={selectedClass?.monthlyResults}
                          />
                        </Grid>
                        <Grid item xs={12} xl={6}>
                          <TaskCompletionSummary taskCompletion={selectedClass?.taskCompletion} />
                        </Grid>
                        <Grid item xs={12} xl={6}>
                          <QuizResults quizResults={selectedClass?.quizInformation[0]} />
                        </Grid>
                      </Grid>
                    </SuiBox>
                  </div>
                </Card>
              </Grid>
            ) : null}
          </Grid>
        </SuiBox>
        <Footer />
      </DashboardLayout>

      {/* This part will be created dynamically, after saving pdf this part will be hidden */}
      {selectedClass !== null && selectedClass !== undefined ? (
        <div className="class-reports-container-to-pdf" id="to-pdf" ref={pdfContainerRef}>
          <ReportHeader classInformation={selectedClass?.className} />
          <div className="class-reports-line" />
          <ClassGeneralInfo
            studentCount={selectedClass?.studentCount}
            readingCount={
              selectedClass?.generalInformation?.reduce((total, current) => {
                if (current.type === "READ") {
                  return total + current.count;
                }
                return total;
              }, 0) ?? 0
            }
            listeningCount={
              selectedClass?.generalInformation?.reduce((total, current) => {
                if (current.type === "LISTEN") {
                  return total + current.count;
                }
                return total;
              }, 0) ?? 0
            }
            recordingCount={
              selectedClass?.generalInformation?.reduce((total, current) => {
                if (current.type === "RECORD") {
                  return total + current.count;
                }
                return total;
              }, 0) ?? 0
            }
            quizCount={
              selectedClass?.generalInformation?.reduce((total, current) => {
                if (current.type === "QUIZ") {
                  return total + current.count;
                }
                return total;
              }, 0) ?? 0
            }
          />

          <div className="charts-container">
            <MonthlyTaskComparisonChart monthlyResults={selectedClass?.monthlyResults} />
            <MonthlyReadingTaskIncentiveOrNotComparison
              monthlyResults={selectedClass?.monthlyResults}
            />
            <TaskCompletionSummary taskCompletion={selectedClass?.taskCompletion} />
            <QuizResults quizResults={selectedClass?.quizInformation[0]} />
          </div>
        </div>
      ) : null}
    </>
  );
};

ClassReports.defaultProps = {
  generalClassReports: [],
  localizations: null,
  suborganization: 0,
};

ClassReports.propTypes = {
  getReports: PropTypes.func.isRequired,
  generalClassReports: PropTypes.arrayOf(PropTypes.any),
  localizations: PropTypes.objectOf(PropTypes.any),
  suborganization: PropTypes.number,
};

const mapStateToProps = (state) => ({
  generalClassReports: state.data.generalClassReports,
  localizations: state.localization?.pairs,
  suborganization: state.header?.suborganization,
});

const mapDispatchToProps = {
  getReports: getGeneralClassReports,
};

export default connect(mapStateToProps, mapDispatchToProps)(ClassReports);
